import React from 'react';
import { Link } from 'react-router-dom';

const FloatingInfoButton: React.FC = () => {
  return (
    <Link
      to="/flugplatzinfo"
      className="fixed bottom-5 right-5 w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-blue-700 hover:shadow-xl hover:scale-110 transition-all duration-200 z-50"
      aria-label="Flugplatzinformationen"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-7 w-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </Link>
  );
};

export default FloatingInfoButton; 